import TestDriveService from "@/services/testdrive.service";

export const testdrive = {
	namespaced: true,
	state: {
		items: [],
		statuses: ['New', 'Approved'],
	},
	actions: {
		search({ commit }, data) {
			return TestDriveService.search(data).then(
				data => {
					commit('search_OK', data);
					return Promise.resolve(data);
				},
				error => {
					commit('search_ERR');
					return Promise.reject(error);
				}
			);
		},
		update({ commit }, data) {
			commit('update_OK', data);
		},
		updateStatuses({ commit }, data) {
			commit('updateStatuses_OK', data);
		},
	},
	mutations: {
		search_OK(state, items) {
			state.items = items;
		},
		search_ERR(state) {
			state.items = [];
		},
		updateStatuses_OK(state, statuses) {
			state.statuses = statuses;
		},
		update_OK: (state, item) => {
			const existsAtIndex = state.items.findIndex(u => u.testDriveID === item.testDriveID);
			if (existsAtIndex !== -1) {
				state.items[existsAtIndex] = item;
			} else {
				state.items.unshift(item); ///instead of push
			}
			state.items = [...state.items];
		},














	}
};

